/* PureState ingredients drawer (sections/ps-ingredients-drawer.liquid), built 2026-09-08.
   Opens from any [data-ps-ingredients-open] control (ps-cta action open_ingredients) or ?<open_param>=open.
   Content is cloned from the inert <template> on first open, so the page pays nothing for it until then.
   Focus trap, focus return, body scroll lock, inert page behind, ESC / backdrop / X / swipe-down to close.
   Closes the cart drawer when it opens, and vice versa. No Romanian literals: every label comes from the section. */
(function () {
  'use strict';
  if (customElements.get('ps-ingredients-drawer')) return;
  var doc = document;
  var FOCUSABLE = 'a[href],area[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';

  customElements.define('ps-ingredients-drawer', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.ps-idr__panel');
      this.backdrop = this.querySelector('[data-ps-idr-backdrop]');
      this.bodyEl = this.querySelector('[data-ps-idr-body]');
      this.tpl = this.querySelector('[data-ps-idr-content]');
      this.handle = this.querySelector('[data-ps-idr-handle]');
      if (!this.panel || !this.backdrop || !this.bodyEl) return;

      this.isOpen = false;
      this.filled = false;
      this.opener = null;
      this.scrollY = 0;

      this.onDocClick = this.onDocClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onBackdrop = this.onBackdrop.bind(this);
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);

      doc.addEventListener('click', this.onDocClick, true);
      this.backdrop.addEventListener('click', this.onBackdrop);
      this.querySelectorAll('[data-ps-idr-close]').forEach(function (b) { b.addEventListener('click', this.close.bind(this)); }, this);
      if (this.handle) {
        this.handle.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.handle.addEventListener('touchmove', this.onTouchMove, { passive: false });
        this.handle.addEventListener('touchend', this.onTouchEnd);
      }

      /* a cart drawer opening closes this one */
      var self = this;
      var cart = doc.querySelector('cart-drawer');
      if (cart) {
        this.cartObserver = new MutationObserver(function () {
          if (self.isOpen && cart.classList.contains('animate') && cart.classList.contains('active')) self.close({ silent: true });
        });
        this.cartObserver.observe(cart, { attributes: true, attributeFilter: ['class'] });
      }

      /* ?<param>=open */
      try {
        var param = this.dataset.openParam || 'ingrediente';
        if (new URLSearchParams(location.search).get(param) === 'open') {
          requestAnimationFrame(function () { self.open(null); });
        }
      } catch (e) {}
    }

    disconnectedCallback() {
      doc.removeEventListener('click', this.onDocClick, true);
      doc.removeEventListener('keydown', this.onKey, true);
      if (this.cartObserver) this.cartObserver.disconnect();
      if (this.isOpen) this.unlock();
    }

    /* capture phase so a trigger's own handlers never navigate first */
    onDocClick(e) {
      var t = e.target && e.target.closest && e.target.closest('[data-ps-ingredients-open]');
      if (!t) return;
      if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      e.stopPropagation();
      this.open(t);
    }

    fill() {
      if (this.filled || !this.tpl) return;
      this.bodyEl.appendChild(this.tpl.content.cloneNode(true));
      this.filled = true;
    }

    open(opener) {
      if (this.isOpen) return;
      this.fill();
      this.opener = opener || doc.activeElement;
      if (this.dataset.closeCart === 'true') {
        var cart = doc.querySelector('cart-drawer');
        if (cart && typeof cart.close === 'function' && cart.classList.contains('active')) cart.close();
      }
      /* a close transition may still be pending from a rapid previous cycle — cancel it, or it would
         hide the panel we are about to show */
      if (this.hideT) { clearTimeout(this.hideT); this.hideT = null; }
      this.backdrop.hidden = false;
      this.panel.hidden = false;
      this.lock();
      this.setInert(true);
      /* next frame so the transition runs from the off-screen position */
      var self = this;
      requestAnimationFrame(function () {
        self.backdrop.classList.add('is-on');
        self.panel.classList.add('is-on');
      });
      this.isOpen = true;
      doc.addEventListener('keydown', this.onKey, true);
      this.panel.focus();
      this.dispatchEvent(new CustomEvent('ps:ingredients:open', { bubbles: true }));
    }

    close(opts) {
      if (!this.isOpen) return;
      opts = opts || {};
      var self = this;
      this.backdrop.classList.remove('is-on');
      this.panel.classList.remove('is-on');
      this.isOpen = false;
      doc.removeEventListener('keydown', this.onKey, true);
      this.setInert(false);
      this.unlock();
      /* Focus goes back to whatever opened the drawer, but only once the panel is actually hidden: a click
         on the X leaves focus on the X, and hiding the panel afterwards would drop focus to <body>
         (measured 2026-09-08). preventScroll keeps an off-screen trigger from yanking the page. */
      var back = opts.silent ? null : this.opener;
      this.opener = null;
      var done = function () {
        self.hideT = null;
        self.panel.hidden = true;
        self.backdrop.hidden = true;
        self.panel.style.transform = '';
        if (back && doc.contains(back) && typeof back.focus === 'function') {
          try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
        }
      };
      var ms = parseFloat(getComputedStyle(this.panel).transitionDuration || '0') * 1000;
      if (ms > 0) this.hideT = setTimeout(done, ms); else done();
      this.dispatchEvent(new CustomEvent('ps:ingredients:close', { bubbles: true }));
    }

    /* Scroll lock by overflow only — never position:fixed. Fixing the body zeroes window.scrollY and the
       restore has to be replayed on every close, which drifted by ~1000px over ten quick cycles (measured
       2026-09-08). overflow:hidden on <html> holds the position by itself. The body keeps the
       .overflow-hidden class because that is the signal the sticky pill already watches. */
    lock() {
      var b = doc.body, h = doc.documentElement, self = this;
      if (b.dataset.psIdrLocked === '1') return;
      b.dataset.psIdrLocked = '1';
      this.lockedY = window.scrollY || 0;
      this.prevHtmlOverflow = h.style.overflow;
      h.style.overflow = 'hidden';
      b.classList.add('overflow-hidden');
      /* overflow:hidden stops the wheel and most touch scrolling, but not window.scrollTo and not iOS
         Safari's rubber band. Pinning on scroll covers both and, unlike position:fixed, never loses the
         position (that cost ~1000px of drift over ten quick cycles, measured 2026-09-08). */
      this.onPin = function () { if (Math.abs((window.scrollY || 0) - self.lockedY) > 1) window.scrollTo(0, self.lockedY); };
      window.addEventListener('scroll', this.onPin, { passive: true });
    }

    unlock() {
      var b = doc.body, h = doc.documentElement;
      if (b.dataset.psIdrLocked !== '1') return;
      delete b.dataset.psIdrLocked;
      if (this.onPin) { window.removeEventListener('scroll', this.onPin); this.onPin = null; }
      h.style.overflow = this.prevHtmlOverflow || '';
      b.classList.remove('overflow-hidden');
    }

    setInert(on) {
      var main = doc.getElementById('MainContent');
      var nodes = [main, doc.querySelector('.shopify-section-group-header-group'), doc.querySelector('.shopify-section-group-footer-group')];
      nodes.forEach(function (n) {
        if (!n) return;
        if (on) n.setAttribute('inert', ''); else n.removeAttribute('inert');
      });
    }

    onBackdrop() { this.close(); }

    onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.slice.call(this.panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
      });
      if (!items.length) { e.preventDefault(); this.panel.focus(); return; }
      var first = items[0], last = items[items.length - 1], a = doc.activeElement;
      if (e.shiftKey && (a === first || a === this.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }

    /* swipe down on the handle closes the sheet (mobile only; the handle is display:none >=990px) */
    onTouchStart(e) {
      if (!this.isOpen || !e.touches || !e.touches.length) return;
      this.dragY = e.touches[0].clientY;
      this.dragging = true;
      this.panel.style.transition = 'none';
    }

    onTouchMove(e) {
      if (!this.dragging || !e.touches || !e.touches.length) return;
      var dy = e.touches[0].clientY - this.dragY;
      if (dy < 0) return;
      e.preventDefault();
      this.panel.style.transform = 'translateY(' + dy + 'px)';
      this.dragDy = dy;
    }

    onTouchEnd() {
      if (!this.dragging) return;
      this.dragging = false;
      this.panel.style.transition = '';
      if ((this.dragDy || 0) > 90) { this.panel.style.transform = ''; this.close(); }
      else this.panel.style.transform = '';
      this.dragDy = 0;
    }
  });
})();
